import { useState } from 'react';

export function useEditableMode(initialValue = false) {
  const [isEditMode, setIsEditMode] = useState(initialValue);
  const toggleEditMode = () => setIsEditMode(!isEditMode);

  return {
    isEditMode,
    toggleEditMode,
  };
}
